import { makeStyles, Theme } from '@material-ui/core';

import { PALETTE_NEUTRAL_DARK } from 'utils/colours';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: 600,
    overflow: 'hidden',
    boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
    minWidth: '174px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: '1rem',
    marginLeft: theme.spacing(1),
  },
  subTitle: {
    marginLeft: theme.spacing(3),
    fontSize: '0.75rem',
    color: PALETTE_NEUTRAL_DARK,
  },
  valueX: {
    marginLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  categoryY: {
    marginLeft: theme.spacing(3),
    fontWeight: 400,
    paddingBottom: theme.spacing(1),
  },
}));

export default useStyles;
